import * as React from "react";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import {Option} from "ts-option";
import User from "../../../model/user/User";
import {getUser} from "../../../store/view/user";
import DateUtils from "../../../utils/DateUtils";
import Loading from "../../ui/loading/Loading";
import {RetriggerData} from "../../../api/model/rest";
import moment = require("moment");

interface ComponentProps {
	data: RetriggerData
}

interface ReduxProps {
	user: Option<User>
}

type Props = ComponentProps & ReduxProps

class RetriggeredDataInfo extends React.PureComponent<Props> {
	render() {
		return this.props.user.map(u => <div>Retriggered by <strong>{u.getDisplayName()}</strong>
			{this.props.data.retriggeredAt &&
			<><br/>at <strong>{moment(this.props.data.retriggeredAt).format(DateUtils.JOB_COMPLETE_DATE_FORMAT)}</strong></>}
		</div>)
			.getOrElse(<Loading isLoading={true} spinnerSize={24}/>);
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	return {
		user: getUser(props.data.retriggerer && props.data.retriggerer.id, state)
	}
}

export default connect(mapStateToProps)(RetriggeredDataInfo)
